import React from "react";
import { SpacingContext, SpacingProviderValue } from "components/Shared/SpacingProvider";
import { useContext } from "react";
import { Box } from "@mui/material";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";

const SpacingSelection = () => {
  const spacingContext = useContext<SpacingProviderValue>(SpacingContext);

  return (
    <Box>
      <RadioGroup
        name="spacing"
        value={spacingContext.currentSpacing.code}
        onChange={e => spacingContext.changeSpacing(e.target.value)}>
          {spacingContext.spacingOptions.map(s => (
            <FormControlLabel 
              key={s.code}
              value={s.code} 
              control={<Radio />} 
              label={<><i className="material-icons" style={{ paddingRight: 'var(--padding-10px)' }}>{s.iconName}</i><span>{s.displayName}</span></>}
            />
          ))}
      </RadioGroup>
    </Box>
  );
};

export default SpacingSelection;
